import Global from './global'

export function alert(vue, message, options) {
    return (vue || Global.app).$bvModal.msgBoxOk(message, Object.assign({}, {
        title: "提示",
        okTitle: "关闭",
        centered: true,
        noCloseOnBackdrop: true,
    }, options));
}

export function confirm(vue, message, options) {
    return (vue || Global.app).$bvModal.msgBoxConfirm(message, Object.assign({}, {
        title: "提示",
        okTitle: "确认",
        cancelTitle: "取消",
        centered: true,
        noCloseOnBackdrop: true,
    }, options));
}